'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// /app/node_modules/axios/lib/cancel/isCancel.js
// module id = 411
// module chunks = 0